// extracted by mini-css-extract-plugin
module.exports = {"Arcade_moduleContainer":"style_Arcade_moduleContainer__a2iMi","Arcade_tips":"style_Arcade_tips__BunFF","Arcade_buttonSpacer":"style_Arcade_buttonSpacer__yDI4M"};